export const getDealerBasePath = (): string =>
  window.location.pathname.split("/").slice(0, 5).join("/");
